import uuid from 'uuid/v4';
import Cookie from 'js-cookie';
import superagent from 'superagent';
import { AUTH_API_SETTINGS } from 'services/App/App.constants';

import imageCacheModel from 'models/imageCache';
// eslint-disable-next-line import/no-cycle
import receiptsUploaderModel from 'models/receiptsUploader';

export default class ReceiptsUpload {
  getKeyNameByIdentityIdAndFileExtensionType(identityId, fileTypeExtension) {
    return `${identityId}/${uuid()}.${fileTypeExtension}`;
  }

  uploads(files) {
    files.forEach(file => this.upload(file));
  }

  upload(file) {
    const accessToken = Cookie.get('accessToken');
    const country = 'JP';

    const formData = new FormData();
    formData.append('file', file);

    return new Promise((resolve, reject) => {
      superagent
        .post(`${AUTH_API_SETTINGS[country].API_BASE_URL}/pfm/uploads.json`)
        .set('authorization', `Bearer ${accessToken}`)
        .set('x-api-version', 6)
        .send(formData)
        .end(async (error, response) => {
          if (error || response.status !== 200) {
            console.error(`Error uploading a new file. Error: ${error}`);
            return reject(error);
          }

          const { body } = response;
          const { path: keyName, presigned_urls: presignedUrls } = body;

          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            imageCacheModel.add(keyName, reader.result);
            receiptsUploaderModel.set(keyName, 1, presignedUrls);
          };

          return resolve(body.path);
        });
    });
  }
}
